<template>
  <span class="info-tooltip-container"
        :class="{ 'disabled': disabled }"
        @mouseenter="showTip"
        @mouseleave="showTip">
    <slot name="tooltip-trigger">
      <inline-svg class="info-icon"
                  :src="require('@ui-kit/assets/images/general/info.svg')" />
    </slot>
    <div class="info-content-box t4"
         :class="[{ 'box-hidden': !visible, dark }, ...positionClasses]">
      <slot />
    </div>
  </span>
</template>

<script>
export default {
  name: 'infoTooltipWuk',
  props: {
    side: {
      type: String,
      default: 'bottom',
      validator(value) {
        return [ 'top', 'bottom' ].indexOf(value) !== -1;
      },
    },
    position: {
      type: String,
      default: 'left',
      validator(value) {
        return [ 'left', 'right', 'center' ].indexOf(value) !== -1;
      },
    },
    dark: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      visible: false,
    };
  },
  computed: {
    positionClasses() {
      return [ this.side, this.position ];
    },
  },
  methods: {
    showTip(e) {
      if (this.disabled) {
        return;
      }
      e.stopPropagation();
      this.visible = !this.visible;
    },
  },
};
</script>

<style lang="scss" scoped>
$information-icon-side: 1.125rem;
$content-fade-duration: 0.3s;
$offset-from-container: 0.25rem;
$tooltip-positioning-offset: 1.5rem;

@mixin positioningClasses($color) {
  &.bottom {
    top: calc((100% + #{$offset-from-container} * 3));

    @include bubble-arrow(top, $color);

    &.left {
      @include bubble-arrow(top, $color, calc((100% - #{$tooltip-positioning-offset} - #{$bubble-arrow-size} * 2)));
    }

    &.right {
      @include bubble-arrow(top, $color, calc(#{$tooltip-positioning-offset} + #{$bubble-arrow-size}));
    }
  }

  &.top {
    bottom: calc((100% + #{$offset-from-container} * 3));
    @include bubble-arrow(bottom, $color, calc(50% - (#{$information-icon-side} / 2)));

    &.left {
      @include bubble-arrow(bottom, $color, calc((100% - #{$tooltip-positioning-offset} - #{$bubble-arrow-size} * 2.5)));
    }

    &.right {
      @include bubble-arrow(bottom, $color, calc(#{$tooltip-positioning-offset} + #{$bubble-arrow-size}));
    }
  }
}

.info-tooltip-container {
  display: inline-block;
  position: relative;
  height: $information-icon-side;

  svg.info-icon {
    width: $information-icon-side;
    width: $information-icon-side;
  }

  &:not(.disabled):hover {
    cursor: pointer;

    .info-content-box {
      opacity: 1;
      visibility: visible;
      transition: visibility 0s, opacity $content-fade-duration linear;
    }
  }
}

.info-content-box {
  position: absolute;
  border-radius: 0.5rem;
  background-color: white;
  padding: 0.5rem;
  box-shadow: $default-shadow-wuk;
  width: max-content;
  max-width: 20rem;
  opacity: 0;
  visibility: hidden;
  z-index: 1;
  min-width: 0;

  &.box-hidden {
    transition: visibility $content-fade-duration, opacity $content-fade-duration linear;
  }

  &.dark {
    background-color: getColor($blues-wuk, 8);
    color: getColor($blues-wuk, 1);
    @include positioningClasses(getColor($blues-wuk, 8));
  }

  &:not(.dark) {
    @include positioningClasses(white);
  }

  &.center {
    left: 50%;
    transform: translateX(-50%);
  }

  &.right {
    transform: translateX(calc(-#{$tooltip-positioning-offset}));
  }

  &.left {
    transform: translateX(calc(-100% + #{$information-icon-side} + #{$tooltip-positioning-offset}));
  }
}
</style>
